const useReadStorage = (itemName: string) => {
  return localStorage.getItem(itemName);
};

export default useReadStorage;
